"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Forms = void 0;
const types_1 = require("@air/types");
const request_1 = require("./request");
const util_1 = require("./util");
/** Create new form */
function createForm(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, form, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.forms, {
            method: 'POST',
            body: form,
            workspaceId,
            boardContext: form.boardId,
        });
    });
}
/** Update form associated with the target formId */
function updateForm(_a) {
    return __awaiter(this, arguments, void 0, function* ({ workspaceId, form, }) {
        return (0, request_1.airRequest)(types_1.EndpointType.forms, {
            endpoint: `${form.id}`,
            method: 'PATCH',
            body: form,
            workspaceId,
        });
    });
}
/** List forms */
function listForms(_a) {
    return __awaiter(this, void 0, void 0, function* () {
        var { workspaceId } = _a, rest = __rest(_a, ["workspaceId"]);
        return (0, request_1.airRequest)(types_1.EndpointType.forms, {
            method: 'GET',
            endpoint: `?${(0, util_1.formatParamsForHttp)(rest)}`,
            workspaceId,
            boardContext: rest.boardId,
        });
    });
}
exports.Forms = {
    createForm,
    updateForm,
    listForms,
};
//# sourceMappingURL=forms.js.map